/* tslint:disable */
/* eslint-disable */
/**
 * Sellsen API
 * Ürün Tarama ve SP-API Entegrasyonu
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Check if a given object implements the OrderTrackingCountsDTO interface.
 */
export function instanceOfOrderTrackingCountsDTO(value) {
    return true;
}
export function OrderTrackingCountsDTOFromJSON(json) {
    return OrderTrackingCountsDTOFromJSONTyped(json, false);
}
export function OrderTrackingCountsDTOFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'delayed': json['delayed'] == null ? undefined : json['delayed'],
        'dueSoon': json['dueSoon'] == null ? undefined : json['dueSoon'],
        'trackingMismatch': json['trackingMismatch'] == null ? undefined : json['trackingMismatch'],
        'noTracking': json['noTracking'] == null ? undefined : json['noTracking'],
        'notPurchased': json['notPurchased'] == null ? undefined : json['notPurchased'],
        'amazonConfirmationMissing': json['amazonConfirmationMissing'] == null ? undefined : json['amazonConfirmationMissing'],
        'awaitingWarehouseReceipt': json['awaitingWarehouseReceipt'] == null ? undefined : json['awaitingWarehouseReceipt'],
        'supplierDelayed': json['supplierDelayed'] == null ? undefined : json['supplierDelayed'],
        'supplierNotArriving': json['supplierNotArriving'] == null ? undefined : json['supplierNotArriving'],
    };
}
export function OrderTrackingCountsDTOToJSON(json) {
    return OrderTrackingCountsDTOToJSONTyped(json, false);
}
export function OrderTrackingCountsDTOToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'delayed': value['delayed'],
        'dueSoon': value['dueSoon'],
        'trackingMismatch': value['trackingMismatch'],
        'noTracking': value['noTracking'],
        'notPurchased': value['notPurchased'],
        'amazonConfirmationMissing': value['amazonConfirmationMissing'],
        'awaitingWarehouseReceipt': value['awaitingWarehouseReceipt'],
        'supplierDelayed': value['supplierDelayed'],
        'supplierNotArriving': value['supplierNotArriving'],
    };
}
